import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export default function Splash() {
  const { t } = useLanguage();
  return (
    <div className="splash-screen">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
        <div className="splash-logo" aria-hidden>🏘️</div>
        <div className="splash-title">{t('appName')}</div>
        <div className="splash-sub">{t('splash.sub')}</div>
      </div>
      <div className="splash-dots" aria-hidden>
        <span className="splash-dot" />
        <span className="splash-dot" />
        <span className="splash-dot" />
      </div>
    </div>
  );
}
